import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { baseurl } from "../../../CommonComponents/baseurl";
import Skeleton from "@mui/material/Skeleton";
import { Img } from "../../../subComponents/img";

// Swiper Imports
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

// Swiper Styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";


function HeroSection() {
  const [category, setCategorys] = useState(null);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        // const response = await fetch(`${baseurl}/api/category`, {
        const response = await fetch(`${baseurl}/api/product-list`, {
          method: "GET",
        });
        const data = await response.json();
        if (data.success === "1") {
          setCategorys(data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCategory();
  }, []);

  return (
    <section className="outer_hero_section" style={{ background: "#f5f5f5", padding: "40px 0", paddingTop:"70px"}}>
      <div className="hero_slider_container">
        {category === null ? (
          <Skeleton variant="rectangular" width="100%" height="400px" />
        ) : (
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            loop={true}
            coverflowEffect={{
              rotate: 0,
              stretch: 80, 
              depth: 200,
              modifier: 1,
              slideShadows: false,
            }}
            navigation={true}
            pagination={{ clickable: true }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="mySwiper"
            style={{paddingBottom:"80px"}}
          >
            {category.map((items, index) => (
              <SwiperSlide key={index} className="custom_slide">
                <NavLink to={items.hyperlink} style={{ textDecoration: "none" }}>
                  <div className="slider_card_wrapper">
                    <div className="image_box">
                      <Img src={items.image} alt={items.title} />
                    </div>
                    <div className="content_bar">
                      <h6 dangerouslySetInnerHTML={{ __html: items.title }}></h6>
                    </div>
                  </div>
                </NavLink>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
}

export default HeroSection;